export const environment = {
  production: true,
  useHash: false,
  inDev: false,
  qa: false,
  aws: {
    cognito: {
      UserPoolId: "eu-west-1_7qre3K7aN",
      ClientId: "78fe04ngpmrualq67a5p59sbeb",
    },
    iot: {
      IdentityPoolId: "eu-west-1:755b46f5-8e6c-4ef0-bd05-4468a477b6ed",
      Region: "eu-west-1",
      Login: "cognito-idp.eu-west-1.amazonaws.com/eu-west-1_7qre3K7aN",
      Connection: {
        protocol: "wss",
        host: "axhipzdhdp7t3-ats.iot.eu-west-1.amazonaws.com",
        port: 443,
      },
    },
  },
  uiApi: {
    url: "https://uiapi.redy.edp.com",
  },
  api: {
    url: "https://redy.edp.pt",
    clientId: "edpportal",
    clientSecret: "15125383-0BFF-4945-B557-D2AC31D1A1AE",
  },
  messagingApi: {
    url: "https://uiapi.edpredy.com",
    apiHeaderKey: "x-api-key",
    apiHeaderValue: "hh7rceai4AnOUroaNDgB9NhuUfUJUP33mkdo2Yb5",
  },
  reports: {
    url: "https://report.redy.edp.pt",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.prd.ts